// Shared therapist color system used by DataTable and ScheduleBoard so a
// therapist has the identical color in both views.

// Fixed 5-color pastel palette: Mustard, Flamingo, Seafoam, Sky, Purple.
export const PALETTE = ["#FCEE9E", "#F6C6C7", "#92CEA8", "#8BD2EC", "#B5B1C8"];
export const NEUTRAL_BORDER = "#CBD5E1";

// Dynamic daily mapping: unique therapist names, sorted consistently, mapped
// sequentially to palette[index % 5] — stable across re-renders.
export const buildTherapistColorMap = (names) => {
  const set = new Set((names || []).filter(Boolean));
  const map = {};
  [...set].sort((a, b) => a.localeCompare(b)).forEach((n, i) => {
    map[n] = PALETTE[i % PALETTE.length];
  });
  return map;
};

// Soft pastel tint of a palette hex (border/dots keep the solid hex).
export const softTint = (hex, a = 0.4) => {
  const h = (hex || "").replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

// Solid white pill badge so cell contents stay legible over colored rows/cards.
export const PILL = {
  backgroundColor: "#FFFFFF",
  border: "1px solid #E2E8F0",
  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  borderRadius: "9999px",
  display: "inline-flex",
  alignItems: "center",
};
